// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3iBfh","notes":"Notes_notes__3WDUn","note":"Notes_note__aYbyM","markdown":"Notes_markdown__1JJck"};